import { registerReactComponents } from '../controllers/react_island_controller';

import SlotPicker from '../components/SlotPicker';
import ManifestInput from '../components/ManifestInput';
import AddressInput from '../components/AddressInput';
import WidgetGiftaid from '../components/WidgetGiftaid';
import PhotoUploader from '../apps/PhotoUploader';

import '../../stylesheets/widget/index.scss';

registerReactComponents({
  SlotPicker,
  ManifestInput,
  AddressInput,
  WidgetGiftaid,
  PhotoUploader,
});

const TRACKING_WHITELIST = ['fbclid', 'gclid', 'ttclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

function emitWidgetEvent(event, data) {
  window.parent.postMessage({ boxmove: true, event, data }, '*');
}

window.resizeIframe = function() {
  const height = Math.max(document.body.clientHeight,400);
  window.parent.postMessage(['setHeight', `${height}px`], '*');
}

document.addEventListener("turbo:load", function() {
  setInterval( () => {
    resizeIframe();
  }, 500);
});

document.addEventListener("turbo:load", function() {
  const addressForm = document.querySelector('#address_form');
  if (addressForm) {
    addressForm.addEventListener('submit', function() {
      const postcodeField = document.querySelector('[name="job[postal_code]"]');
      const postcode = postcodeField ? postcodeField.value.trim() : '';
      if (!postcode) return;

      const params = new URLSearchParams(window.location.search);
      const tracking = {};
      TRACKING_WHITELIST.forEach(function(key) {
        if (params.has(key)) tracking[key] = params.get(key);
      });

      // Store postcode and tracking in sessionStorage for service status detection on next page
      sessionStorage.setItem('boxmovePostcodeSearch', JSON.stringify({ postcode, tracking }));
    });
  }

  // Fire offer.postcode_search on booking or too_far pages with service status
  const serviceStatusEl = document.getElementById('boxmove-service-status');
  const storedData = sessionStorage.getItem('boxmovePostcodeSearch');
  if (serviceStatusEl && storedData) {
    const serviceStatus = serviceStatusEl.dataset.status || 'unknown';
    const { postcode, tracking } = JSON.parse(storedData);
    emitWidgetEvent('offer.postcode_search', { postcode, tracking, serviceStatus });
    // Clear stored data after emitting
    sessionStorage.removeItem('boxmovePostcodeSearch');
  }

  const analyticsEl = document.querySelector('[data-analytics-event-value="completed"]');
  if (analyticsEl) {
    let analytics = {};
    try {
      analytics = JSON.parse(analyticsEl.dataset.analyticsDataValue || '{}');
    } catch (e) {}

    let tracking = {};
    try {
      const trackingEl = document.getElementById('boxmove-tracking');
      tracking = JSON.parse(trackingEl?.dataset?.tracking || '{}');
    } catch (e) {}

    const { jobId, postcode, shop } = analytics;
    const estimatedValue = analytics.donation?.estimatedValue;
    const numberOfItems = analytics.donation?.numberOfItems;

    emitWidgetEvent('offer.booked', { jobId, postcode, shop, estimatedValue, numberOfItems, tracking });
  }
});
